<template>
  <app-data-editor
    :id="id"
    title="Редактирование единицы измерения веса"
    resource="units"
    :elements="elements"
    add-message="Единица измерения добавлена"
    edit-message="Единица измерения изменена"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [(v) => !!v || "Наименование обязательно к заполнению"],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
